package co.torvus.web.components

import co.torvus.web.classes
import co.torvus.web.content.navItems
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import web.cssom.ClassName

external interface MobileMenuProps : Props {
    var active: String
    var onNavigate: (String) -> Unit
    var onClose: () -> Unit
}

val MobileMenu = FC<MobileMenuProps> { props ->
    div {
        className = ClassName("mobile-menu")

        DottedBackground {}

        button {
            className = ClassName("menu-close")
            onClick = { props.onClose() }
            +"×"
        }

        navItems.forEach { item ->
            button {
                className = classes("menu-link", if (props.active == item.id) "active" else null)
                onClick = { props.onNavigate(item.id) }
                +item.label
            }
        }
    }
}
